export enum EUserType {
  DEVELOPER = 'DEVELOPER',
  TESTER = 'TESTER',
  CUSTOMER = 'CUSTOMER',
  UNSET = 'UNSET',
}
